import { charterActions, charterSelector } from '../store/reducers/charterSlice/charterSlice';
import moment from 'moment';
import { getCountDaysFromDate } from '../helpers/getCountDays';
import { positionActions, positionSelector } from '../store/reducers/positionSlice/positionSlice';
import { actions, stageSelector } from '../store/reducers/stageSlice/stageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const useUpdateAll = (stage = {}) => {
    const { t } = useTranslation();
    const stageEntities = useSelector(stageSelector.selectEntities);
    const chartersEntities = useSelector(charterSelector.selectEntities);
    const positionsEntities = useSelector(positionSelector.selectEntities);
    const positionsList = useSelector(positionSelector.selectAll);
    const allStages = useSelector(stageSelector.selectAll);
    const { settings } = useSelector((state) => state.gantReducer);

    const dispatch = useDispatch();

    const getParentStages = (positions) => {
        const stagesGuids = [];

        Object.values(positions).forEach((position) => {
            const foundStage = allStages.find((stage) => {
                const positionsGuids = [];

                stage.positions.forEach((stageChildGuid) => {
                    if (!!chartersEntities[stageChildGuid]) {
                        chartersEntities[stageChildGuid]?.children.forEach((positionGuid) => {
                            positionsGuids.push(positionGuid);
                        });
                    } else {
                        positionsGuids.push(stageChildGuid);
                    }
                });

                return positionsGuids.includes(position.guid);
            });

            if (foundStage && !stagesGuids.includes(foundStage.id)) {
                stagesGuids.push(foundStage.id);
            }
        });

        return stagesGuids;
    };

    const getStageChildren = (positions, item = stage) => {
        let childPosition = [];
        let charters = [];
        let allPositions = [];

        const resultPositions = { ...positionsEntities, ...positions };

        item.positions.forEach((stageChildGuid) => {
            if (!!chartersEntities[stageChildGuid]) {
                charters.push(chartersEntities[stageChildGuid]);

                chartersEntities[stageChildGuid].children.forEach((positionGuid) => {
                    allPositions.push(resultPositions[positionGuid]);
                });
            } else {
                childPosition.push(resultPositions[stageChildGuid]);
                allPositions.push(resultPositions[stageChildGuid]);
            }
        });

        return { childPosition, charters, allPositions };
    };
    const getStageChildrena = (positions, stageId) => {
        let childPosition = [];
        let charters = [];
        let allPositions = [];

        const resultPositions = { ...positionsEntities, ...positions };

        const stage = stageEntities[stageId];

        stage.positions.forEach((stageChildGuid) => {
            if (!!chartersEntities[stageChildGuid]) {
                charters.push(chartersEntities[stageChildGuid]);

                chartersEntities[stageChildGuid].children.forEach((positionGuid) => {
                    allPositions.push(resultPositions[positionGuid]);
                });
            } else {
                childPosition.push(resultPositions[stageChildGuid]);
                allPositions.push(resultPositions[stageChildGuid]);
            }
        });

        return { childPosition, charters, allPositions };
    };

    const updateAll = (positions) => {
        const stages = getParentStages(positions);

        const positionsResult = { ...positionsEntities, ...positions };
        const chartersUpdateData = [];
        const stagesUpdateData = [];
        let positionsUpdateData = [];

        stages.forEach((stageId) => {
            const { allPositions: allStagePositions, charters } = getStageChildrena(
                positions,
                stageId
            );

            const sortedStagePosition = allStagePositions
                .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                .filter((pos) => pos.planned.days_count)
                .sort(
                    (positionA, positionB) =>
                        moment(positionA.planned.end_date).valueOf() -
                        moment(positionB.planned.end_date).valueOf()
                );

            const sortedStageForStart = allStagePositions
                .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                .filter((pos) => pos.planned.days_count)
                .sort(
                    (positionA, positionB) =>
                        moment(positionA.planned.start_date).valueOf() -
                        moment(positionB.planned.start_date).valueOf()
                );

            const sortedStagePositionActual = allStagePositions
                .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                .filter((pos) => pos.actual?.days_count)
                .sort(
                    (positionA, positionB) =>
                        moment(positionA.actual?.end_date).valueOf() -
                        moment(positionB.actual?.end_date).valueOf()
                );

            const sortedStageForStartActual = allStagePositions
                .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                .filter((pos) => pos.actual?.days_count)
                .sort(
                    (positionA, positionB) =>
                        moment(positionA.actual?.start_date).valueOf() -
                        moment(positionB.actual?.start_date).valueOf()
                );

            charters.forEach((charter) => {
                const chartersChildren = [...charter.children]
                    .map((guid) => positionsResult[guid])
                    .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                    .filter((pos) => pos.planned.days_count)
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.planned.end_date).valueOf() -
                            moment(positionB.planned.end_date).valueOf()
                    );

                const chartersChildrenSortForStart = [...charter.children]
                    .map((guid) => positionsResult[guid])
                    .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                    .filter((pos) => pos.planned.days_count)
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.planned.start_date).valueOf() -
                            moment(positionB.planned.start_date).valueOf()
                    );

                const chartersChildrenActual = [...charter.children]
                    .map((guid) => positionsResult[guid])
                    .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                    .filter((pos) => pos.actual?.days_count)
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.actual?.end_date).valueOf() -
                            moment(positionB.actual?.end_date).valueOf()
                    );

                const chartersChildrenSortForStartActual = [...charter.children]
                    .map((guid) => positionsResult[guid])
                    .filter((pos) => (settings.isShowMHD ? true : pos.type === 'labor'))
                    .filter((pos) => pos.actual?.days_count)
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.actual?.start_date).valueOf() -
                            moment(positionB.actual?.start_date).valueOf()
                    );

                let updatedCharter = { ...charter };

                if (chartersChildren.length) {
                    const endDate = chartersChildren.slice(-1)[0].planned.end_date;
                    const startDate = chartersChildrenSortForStart[0].planned.start_date;

                    updatedCharter = {
                        ...updatedCharter,
                        planned: {
                            days_count: `${getCountDaysFromDate(endDate, startDate)}`,
                            start_date: startDate,
                            end_date: endDate,
                        },
                    };
                } else {
                    updatedCharter = {
                        ...updatedCharter,
                        planned: {
                            days_count: null,
                            start_date: null,
                            end_date: null,
                        },
                    };
                }
                if (chartersChildrenActual.length) {
                    const endDateActual = chartersChildrenActual.slice(-1)[0].actual?.end_date;
                    const startDateActual =
                        chartersChildrenSortForStartActual[0].actual?.start_date;

                    updatedCharter = {
                        ...updatedCharter,
                        actual: {
                            days_count: `${getCountDaysFromDate(endDateActual, startDateActual)}`,
                            start_date: startDateActual,
                            end_date: endDateActual,
                        },
                    };
                } else {
                    updatedCharter = {
                        ...updatedCharter,
                        actual: {
                            days_count: null,
                            start_date: null,
                            end_date: null,
                        },
                    };
                }

                chartersUpdateData.push({
                    id: charter.guid,
                    changes: updatedCharter,
                });
            });

            const updateAllPositions = allStagePositions.map((position) => ({
                id: position.guid,
                changes: position,
            }));

            positionsUpdateData = [...positionsUpdateData, ...updateAllPositions];

            let stagePlanned = {
                days_count: null,
                end_date: null,
                start_date: null,
            };

            let stageActual = {
                days_count: null,
                end_date: null,
                start_date: null,
            };
            if (sortedStagePosition.length) {
                const endDate = sortedStagePosition.slice(-1)[0].planned.end_date;
                const startDate = sortedStageForStart[0].planned.start_date;
                stagePlanned = {
                    days_count: `${getCountDaysFromDate(endDate, startDate)}`,
                    start_date: startDate,
                    end_date: endDate,
                };
            }

            if (sortedStagePositionActual.length) {
                const endDate = sortedStagePositionActual.slice(-1)[0].actual?.end_date;
                const startDate = sortedStageForStartActual[0].actual?.start_date;
                stageActual = {
                    days_count: `${getCountDaysFromDate(endDate, startDate)}`,
                    start_date: startDate,
                    end_date: endDate,
                };
            }

            stagesUpdateData.push({
                id: `${stageId}`,
                changes: { ...stageEntities[stageId], planned: stagePlanned, actual: stageActual },
            });
        });

        dispatch(positionActions.updateMany(positionsUpdateData));

        dispatch(charterActions.updateMany(chartersUpdateData));

        const stagesData = stagesUpdateData.map(({ _, changes }) => {
            const { id, ...stageData } = changes;
            return {
                id,
                changes: { ...stageData },
            };
        });

        dispatch(actions.updateMany(stagesData));

        const positionsUpdeted = positionsUpdateData.map(({ id, changes }) => changes);

        let updatedList = { ...positionsEntities };

        positionsUpdeted.forEach((position) => {
            updatedList[position.guid] = position;
        });

        const sortedStart = Object.values(updatedList)
            .filter((position) => !!position?.planned?.days_count)
            .sort(
                (positionA, positionB) =>
                    moment(positionA.planned.start_date).valueOf() -
                    moment(positionB.planned.start_date).valueOf()
            )[0]?.planned?.start_date;

        const sortedEnd = Object.values({ ...updatedList })
            .filter((position) => !!position.planned.days_count)
            .sort(
                (positionA, positionB) =>
                    moment(positionA.planned.end_date).valueOf() -
                    moment(positionB.planned.end_date).valueOf()
            )
            .slice(-1)[0]?.planned?.end_date;

        const sortedEndActual = Object.values({ ...updatedList })
            .filter((position) => !!position.actual.days_count)
            .sort(
                (positionA, positionB) =>
                    moment(positionA.actual.end_date).valueOf() -
                    moment(positionB.actual.end_date).valueOf()
            )
            .slice(-1)[0]?.actual?.end_date;

        moment.locale(LOCALE);
        const start = moment(sortedStart).format('DD MMMM YYYY');
        const end = moment(sortedEnd).format('DD MMMM YYYY');

        const daysDifference = moment(sortedEnd).diff(moment(sortedStart), 'days');

        const startText = sortedStart
            ? `${start} ${i18next.t('useUpdateAll.return.startText')}`
            : '-';
        const endText = sortedStart ? `${end} ${i18next.t('useUpdateAll.return.endText')}` : '-';
        const endTextActual = sortedEndActual
            ? `${moment(sortedEndActual).format('DD MMMM YYYY')} ${i18next.t(
                  'useUpdateAll.return.endTextActual'
              )}`
            : endText;

        function getDayWord(number) {
            const cases = [2, 0, 1, 1, 1, 2];
            const titles = [
                t('Gant.useUpdateAll.getDayWord.titles.day'),
                t('Gant.useUpdateAll.getDayWord.titles.days'),
                t('Gant.useUpdateAll.getDayWord.titles.days_many'),
            ];
            return titles[
                number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]
            ];
        }

        $(document).find('[data-start]').attr('data-start', moment(sortedStart).format());
        $(document)
            .find('[data-start-gantt]')
            .text(`${i18next.t('useUpdateAll.return.data-start-gantt.text')} ${startText}`);
        $(document)
            .find('[data-end-gantt]')
            .text(`${i18next.t('useUpdateAll.return.data-end-gantt.text')} ${endText}`);
        $(document)
            .find('[data-days-gantt]')
            .text(
                `${i18next.t('useUpdateAll.return.data-days-gantt.text')} ${
                    sortedEnd ? daysDifference + 1 : 0
                } ${getDayWord(sortedEnd ? daysDifference + 1 : 0)}`
            );
        $(document)
            .find('[data-days-gantt-forecast]')
            .text(
                `${i18next.t('useUpdateAll.return.data-days-gantt-forecast.text')} ${endTextActual}`
            );
    };

    return { updateAll, getStageChildren };
};
